import SearchItems from './searchItems';
import SearchSubjects from './searchSubjects';
import SearchMulti from './searchMulti';

/**
 * Builds an instance of a search class based on the given arguments.
 *
 * @param {Object} args - The arguments for building the search class
 * @param {String} args.engine - The engine type, e.g. items-st, items-pr, subjects
 * @param {Object} args.filters - The filters to apply to the search
 * @return {ItemsSearch|SearchSubjects}
 */
export default function searchFactory({ engine = 'items-st', filters = {}, facets = {} }) {
  switch(engine) {
    case 'items-st':
    case 'items-pr':
      return new SearchItems({ engine, filters, facets });
    case 'subjects':
      return new SearchSubjects;
    case 'multi-st':
    case 'multi-pr':
      return new SearchMulti({ itemsEngine: `items-${engine.slice(-2)}` });
  }
}
